import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TokenAuthService } from '../services/token-auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private tokenAuthService: TokenAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.tokenAuthService.hasToken) {
      req = req.clone({
        setHeaders: {
          authorization: `Bearer ${this.tokenAuthService.token}`,
        },
      });
    }

    return next.handle(req);
  }
}
